module.exports = __webpack_public_path__ + "static/media/BookReviewColorStudy2.003eccca.jpg";